import useNotifications from '@anm/hooks/useNotifications';

import { CreateBrandFileState } from '../../../../store/modules/brands';

const errorMessage = "Can't add file to brand. Please try again later"; // TODO: discuss messages
const successMessage = 'Brand file has been succesfully added';

const useCreateBrandFileNotification = (entity: CreateBrandFileState) => {
  const { notifications } = useNotifications({
    ...entity,
    successMessage,
    errorMessage
  });

  return notifications;
};

export default useCreateBrandFileNotification;
